import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { ListPreTrainedFieldsQuery } from '@rossum/api-client/engineFields';
import { useApiClient } from '../../../lib/apiClient';
import { pretrainedFieldKeys } from '../keys';

export const usePretrainedFields = (
  filters: ListPreTrainedFieldsQuery = {}
) => {
  const api = useApiClient();
  return useQuery({
    queryKey: pretrainedFieldKeys.list(filters),
    queryFn: () =>
      api.request(endpoints.engineFields.listPreTrainedFields(filters)),
  });
};
